/*
 * HONEYWELL INC.,
 * COPYRIGHT (c) 2022
 * ALL RIGHTS RESERVED
 *
 * This software is a copyrighted work and/or information protected as a trade secret.
 * Legal rights of Honeywell Inc. in this software is distinct from ownership of any medium
 * in which the software is embodied. Copyright or trade secret notices included must be
 * reproduced in any copies authorized by Honeywell Inc.
 *
 */

import { Badge } from '@scuf/common';
import React from 'react';
import { EnergyUsageScopeType } from '../../../../shared/Utils/Constants';
import GasIcon from '../../../../../images/GasIcon.svg';
import WaterIconInActive from '../../../../../images/WaterIconInActive.svg';
import ElectricityIcon from '../../../../../images/Energy-icon.svg';

interface IEnergyBreakDownMeter {
  totalDeviation: number;
  utilityType: string;
  isIconShow: boolean;
  meterCount?: number;
}
const EnergyBreakDownMeterComponent = (props: IEnergyBreakDownMeter) => {
  const { totalDeviation, utilityType, isIconShow, meterCount } = props;
  return (
    <>
      <span className="score-category-meterdata-meter">
        <span className="breakdown-name-badge" />
        {utilityType?.toLowerCase() === EnergyUsageScopeType.ELECTRIC &&
          isIconShow && (
            <img className="card-electricity-icon" src={ElectricityIcon} />
          )}
        {utilityType?.toLowerCase() === EnergyUsageScopeType.Gas &&
          isIconShow && <img className="card-electricity-icon" src={GasIcon} />}
        {utilityType?.toLowerCase() === EnergyUsageScopeType.WATER &&
          isIconShow && (
            <img className="card-electricity-icon" src={WaterIconInActive} />
          )}
        {totalDeviation !== null && totalDeviation < 0 && (
          <Badge
            color={'red'}
            empty={true}
            className="breakdown-name-badge-css-override"
          />
        )}

        <span className="score-category-meterparent">
          {' '}
          {meterCount ? `${utilityType} (${meterCount})` : utilityType}
        </span>
      </span>
    </>
  );
};

export default EnergyBreakDownMeterComponent;
